import QuizPage from '../../src/features/style-quiz/containers/QuizPage';

export default QuizPage;
